<div #baAmChart class="ba-am-chart {{baAmChartClass || ''}}"></div>
